export default __webpack_public_path__ + "static/media/noAccess.a7f7eb4f.svg";